import { useCallback } from 'react';

import postMessageHelper from 'Util/Message/postMessageHelper';
import { TOPIC } from 'Util/Message/TopicName';

import { useClassroomContext } from '../../Context/ClassroomContext';

import { formatBangkokTime, getClassroomEventLabel } from './utils';
import useTracking from './useTracking';

const CLASSROOM_CATEGORY = {
  CLASSROOM: 'Classroom',
};

const CLASSROOM_ACTIONS = {
  HEARTBEAT: 'Heartbeat',
};

const defaultCourseMode = 'TRADITIONAL';
const fallbackValue = '-';

const getClassroomEvent = (action, label, { nonInteraction } = {}) => ({
  category: CLASSROOM_CATEGORY.CLASSROOM,
  action,
  label,
  nonInteraction,
});

function useClassroomVideoTracking() {
  const { logAction } = useTracking();
  const { courseData, courseId } = useClassroomContext();
  const currentSubsection = courseData?.inProgressSubsection ?? {};
  const classroomLabel = getClassroomEventLabel(currentSubsection);
  const courseMode = courseData?.courseMode ?? defaultCourseMode;

  const sendHeartbeat = useCallback(() => {
    logAction(
      getClassroomEvent(CLASSROOM_ACTIONS.HEARTBEAT, classroomLabel, {
        nonInteraction: true,
      })
    );
    postMessageHelper(TOPIC.CLASSROOM_HEARTBEAT, {
      courseId: courseId ?? fallbackValue,
      revision: courseData?.courseRevision ?? fallbackValue,
      subsectionId: currentSubsection.id ?? fallbackValue,
      subsectionTitle: currentSubsection.title ?? fallbackValue,
      subsectionContentType: currentSubsection.contentType ?? fallbackValue,
      clientTimestamp: formatBangkokTime(),
      courseMode,
    });
  }, [
    logAction,
    classroomLabel,
    courseId,
    courseData?.courseRevision,
    currentSubsection.id,
    currentSubsection.title,
    currentSubsection.contentType,
    courseMode,
  ]);

  return {
    sendHeartbeat,
  };
}

export { useClassroomVideoTracking };
